<template>
  <ThemeProvider :theme="currentTheme">
    <div class="cs-overlay">
      <div class="cs-overlay__content">
        <div class="cs-overlay__logo">
          <Logo size="60" color="primary" only-mark />
        </div>
        <template v-if="error.statusCode === 404">
          <VText class="cs-overlay__title" component="h1" variant="h3"
            >You look lost</VText
          >
          <VText class="cs-overlay__text"
            >This page doesn't seem to exist.</VText
          >
        </template>
        <template v-else>
          <VText class="cs-overlay__title" component="h1" variant="h3"
            >Server Error</VText
          >
          <VText class="cs-overlay__text"
            >This page is having some trouble loading. Please
            <a href="mailto:support@campsite.bio">contact us</a> if this issue
            persists.</VText
          >
        </template>

        <div class="cs-overlay__actions">
          <InlineLink href="https://campsite.bio">
            Return to homepage
          </InlineLink>
        </div>
      </div>
    </div>
  </ThemeProvider>
</template>

<script>
import {
  ThemeProvider,
  createThemeFromSettings,
  VText,
  InlineLink,
  Logo,
} from '@campsite-bio/component-lib';
import { computed, useStore } from '@nuxtjs/composition-api';

import defaultOG from '@/assets/default-og';

export default {
  props: ['error'],

  layout: 'errorlayout',

  components: {
    ThemeProvider,
    VText,
    Logo,
    InlineLink,
  },

  head() {
    return {
      title: `${
        this.error.statusCode === 404 ? 'Page Not Found' : 'Server Error'
      } - Campsite`,
      meta: [...defaultOG],
    };
  },

  setup() {
    const store = useStore();

    const theme = computed(() => {
      if (!store.getters.hasCampsite) return 'profile';

      return createThemeFromSettings(store.state.campsite, 'profile');
    });

    return { currentTheme: theme };
  },
};
</script>

<style lang="scss" scoped>
.cs-overlay {
  background: var(--g-color-bg);
  color: var(--g-color-on-bg);
  font: 400 18px/1.4 var(--g-font-body-family);
  display: flex;
  height: 100vh;
  place-content: center space-between;
  flex-direction: column;
  margin-left: -0.925rem;
  margin-right: -0.925rem;
  padding: 2.5rem 0.925rem;
  text-align: center;
  align-items: center;

  &__content {
    margin-top: 5rem;
    max-width: 600px;
    width: 92%;
  }

  &__logo {
    margin-bottom: 1.5rem;
  }

  &__actions {
    font-size: 1rem;
    margin-top: 2rem;
  }
}

.cs-overlay__title.cs-overlay__title {
  margin-bottom: 0.5rem;
}

.cs-overlay__text.cs-overlay__text {
  margin-bottom: 1rem;
}
</style>
